// src/i18n/locales/es.js

export default {
  countries: {
    'AF': 'Afganistán',
    'AL': 'Albania',
    'DZ': 'Argelia',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antigua y Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaiyán',
    'BS': 'Bahamas',
    'BH': 'Baréin',
    'BD': 'Bangladés',
    'BB': 'Barbados',
    'BY': 'Bielorrusia',
    'BE': 'Bélgica',
    'BZ': 'Belice',
    'BJ': 'Benín',
    'BT': 'Bután',
    'BO': 'Bolivia',
    'BA': 'Bosnia y Herzegovina',
    'BW': 'Botsuana',
    'BR': 'Brasil',
    'BN': 'Brunéi',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Cabo Verde',
    'KH': 'Camboya',
    'CM': 'Camerún',
    'CA': 'Canadá',
    'CF': 'República Centroafricana',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Colombia',
    'KM': 'Comoras',
    'CG': 'Congo',
    'CD': 'Congo, República Democrática del',
    'CR': 'Costa Rica',
    'CI': 'Costa de Marfil',
    'HR': 'Croacia',
    'CU': 'Cuba',
    'CY': 'Chipre',
    'CZ': 'Chequia',
    'DK': 'Dinamarca',
    'DJ': 'Yibuti',
    'DM': 'Dominica',
    'DO': 'República Dominicana',
    'EC': 'Ecuador',
    'EG': 'Egipto',
    'SV': 'El Salvador',
    'GQ': 'Guinea Ecuatorial',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Etiopía',
    'FJ': 'Fiyi',
    'FI': 'Finlandia',
    'FR': 'Francia',
    'GA': 'Gabón',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Alemania',
    'GH': 'Ghana',
    'GR': 'Grecia',
    'GD': 'Granada',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bisáu',
    'GY': 'Guyana',
    'HT': 'Haití',
    'HN': 'Honduras',
    'HU': 'Hungría',
    'IS': 'Islandia',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Irán',
    'IQ': 'Irak',
    'IE': 'Irlanda',
    'IL': 'Israel',
    'IT': 'Italia',
    'JM': 'Jamaica',
    'JP': 'Japón',
    'JO': 'Jordania',
    'KZ': 'Kazajistán',
    'KE': 'Kenia',
    'KI': 'Kiribati',
    'KP': 'Corea del Norte',
    'KR': 'Corea del Sur',
    'KW': 'Kuwait',
    'KG': 'Kirguistán',
    'LA': 'Laos',
    'LV': 'Letonia',
    'LB': 'Líbano',
    'LS': 'Lesoto',
    'LR': 'Liberia',
    'LY': 'Libia',
    'LI': 'Liechtenstein',
    'LT': 'Lituania',
    'LU': 'Luxemburgo',
    'MG': 'Madagascar',
    'MW': 'Malaui',
    'MY': 'Malasia',
    'MV': 'Maldivas',
    'ML': 'Malí',
    'MT': 'Malta',
    'MH': 'Islas Marshall',
    'MR': 'Mauritania',
    'MU': 'Mauricio',
    'MX': 'México',
    'FM': 'Micronesia',
    'MD': 'Moldavia',
    'MC': 'Mónaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MA': 'Marruecos',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Países Bajos',
    'NZ': 'Nueva Zelanda',
    'NI': 'Nicaragua',
    'NE': 'Níger',
    'NG': 'Nigeria',
    'MK': 'Macedonia del Norte',
    'NO': 'Noruega',
    'OM': 'Omán',
    'PK': 'Pakistán',
    'PW': 'Palaos',
    'PS': 'Palestina, Estado de',
    'PA': 'Panamá',
    'PG': 'Papúa Nueva Guinea',
    'PY': 'Paraguay',
    'PE': 'Perú',
    'PH': 'Filipinas',
    'PL': 'Polonia',
    'PT': 'Portugal',
    'QA': 'Catar',
    'RO': 'Rumanía',
    'RU': 'Rusia',
    'RW': 'Ruanda',
    'KN': 'San Cristóbal y Nieves',
    'LC': 'Santa Lucía',
    'VC': 'San Vicente y las Granadinas',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Santo Tomé y Príncipe',
    'SA': 'Arabia Saudita',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leona',
    'SG': 'Singapur',
    'SK': 'Eslovaquia',
    'SI': 'Eslovenia',
    'SB': 'Islas Salomón',
    'SO': 'Somalia',
    'ZA': 'Sudáfrica',
    'SS': 'Sudán del Sur',
    'ES': 'España',
    'LK': 'Sri Lanka',
    'SD': 'Sudán',
    'SR': 'Surinam',
    'SZ': 'Esuatini',
    'SE': 'Suecia',
    'CH': 'Suiza',
    'SY': 'Siria',
    'TJ': 'Tayikistán',
    'TZ': 'Tanzania',
    'TH': 'Tailandia',
    'TL': 'Timor Oriental',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad y Tobago',
    'TN': 'Túnez',
    'TR': 'Turquía',
    'TM': 'Turkmenistán',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ucrania',
    'AE': 'Emiratos Árabes Unidos',
    'GB': 'Reino Unido',
    'US': 'Estados Unidos',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistán',
    'VU': 'Vanuatu',
    'VA': 'Ciudad del Vaticano',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabue'
  },
  verification: {
    verifying: 'Verificando su correo electrónico...',
    success: '¡Correo Electrónico Verificado con Éxito!',
    failed: 'Verificación Fallida',
    accountVerified: 'Su cuenta ha sido verificada con éxito. Ahora puede iniciar sesión en su cuenta.',
    invalidLink: 'El enlace de verificación es inválido o ha expirado.',
    missingToken: 'Falta el token de verificación.',
    generalError: 'Ocurrió un error durante la verificación. Por favor, intente nuevamente más tarde.',
    proceedToLogin: 'Proceder a Iniciar Sesión',
    backToLogin: 'Volver a Iniciar Sesión'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Panel de Control',
    system: 'Sistema',
    settings: 'Configuraciones',
    overview: 'Resumen',
    database: 'Base de Datos',
    logs: 'Registros',
    userManagement: 'Gestión de Usuarios',
    security: 'Seguridad',
    systemAdministration: 'Administración del Sistema',
    loading: 'Cargando...',
    close: 'Cerrar panel de control',
    edit: 'Editar',
    systemUptime: 'Tiempo de Actividad del Sistema',
    avgResponseTime: 'Tiempo de Respuesta Promedio',
    errorRate: 'Tasa de Error',
    activeUsers: 'Usuarios Activos',
    monthlyActiveUsers: 'Usuarios Activos Mensuales (MAU)',
    fromLastMonth: 'del mes pasado',
    today: 'Hoy',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'Salud del Sistema',
      hierarchy: 'Jerarquía de Conocimiento', // NEW
      documents: 'Gestión de Documentos', // NEW
      database: 'Base de Datos',
      logs: 'Registros',
      security: 'Seguridad',
      users: 'Usuarios'
    },
    // --- NEW KEYS ---
    contentManagement: "GESTIÓN DE CONTENIDO",
    knowledgeHierarchy: "Jerarquía de Conocimiento",
    documentManagement: "Gestión de Documentos",
    noLogsFound: "No se encontraron registros para hoy",
    invalidLogsResponse: "Estructura de respuesta de resumen de registros no válida",
    logsSummaryError: "Error al cargar el resumen de registros",
    buttons: {
      save: "Guardar",
      cancel: "Cancelar",
      switch: "Cambiar de todos modos",
      discard: "Descartar"
    },
    confirm: {
      defaultTitle: "Confirmar",
      defaultMessage: "¿Está seguro?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Estado de Salud del Sistema',
    runDiagnostics: 'Ejecutar Diagnósticos',
    resourceUsage: 'Uso de Recursos',
    services: {
      apiServices: 'Servicios API',
      database: 'Base de Datos',
      cache: 'Caché',
      storage: 'Almacenamiento',
      messageQueue: 'Cola de Mensajes',
      externalApi: 'API Externa'
    },
    resources: {
      cpu: 'Uso de CPU',
      memory: 'Uso de Memoria',
      storage: 'Uso de Almacenamiento',
      network: 'Ancho de Banda de Red'
    },
    databaseManagement: 'Gestión de Base de Datos',
    reindexDatabase: 'Reindexar Base de Datos',
    lastReindex: 'Última Reindexación',
    databaseSize: 'Tamaño de la Base de Datos',
    totalTables: 'Tablas Totales',
    logManagement: 'Gestión de Registros',
    rolloverLogs: 'Rotar Registros',
    searchLogs: 'Buscar Registros',
    logTime: 'Tiempo',
    logLevel: 'Nivel',
    logService: 'Servicio',
    logMessage: 'Mensaje',
    showingEntries: 'Mostrando {start}-{end} de {total} entradas',
    logLevels: {
      error: 'ERROR',
      warn: 'ADVERTENCIA',
      info: 'INFO',
      debug: 'DEPURAR'
    },
    logMessages: {
      connectionTimeout: 'Tiempo de conexión agotado al proveedor externo',
      lowDiskSpace: 'Espacio en disco por debajo del umbral del 10%',
      userRoleUpdated: 'Rol de usuario actualizado para admin@huduma.ai'
    },
    userName: 'Nombre',
    userEmail: 'Correo Electrónico',
    userRole: 'Rol',
    userStatus: 'Estado',
    userActions: 'Acciones',
    roleAdministrator: 'Administrador',
    roleUser: 'Usuario',
    statusActive: 'Activo',
    dbActions: {
      reindex: 'Reindexar',
      backup: 'Respaldo',
      optimize: 'Optimizar',
      reindexDesc: 'Reconstruir índices de la base de datos',
      backupDesc: 'Crear respaldo de la base de datos',
      optimizeDesc: 'Optimizar el rendimiento de consultas'
    },
    operations: {
      reindexTitle: 'Resultados de Reindexación de Base de Datos',
      backupTitle: 'Resultados de Respaldo de Base de Datos',
      optimizeTitle: 'Resultados de Optimización de Base de Datos',
      reindexResults: 'Resultados de Reindexación',
      optimizeResults: 'Resultados de Optimización',
      collection: 'Colección',
      status: 'Estado',
      indexSuggestions: 'Sugerencias de Índices',
      backupDetails: 'Detalles de Respaldo',
      backupFile: 'Archivo de Respaldo',
      backupLocation: 'Ubicación',
      backupSize: 'Tamaño',
      errorDetails: 'Detalles de Error',
      close: 'Cerrar',
      resultsTitle: 'Resultados de Operación',
      reindexDatabase: {
        success: 'Reindexación de base de datos completada con éxito',
        error: 'Error durante la reindexación de la base de datos',
        loading: 'Reindexando base de datos...'
      },
      backupDatabase: {
        success: 'Respaldo de base de datos completado con éxito',
        error: 'Error durante el respaldo de la base de datos',
        loading: 'Respaldando base de datos...'
      },
      optimizeDatabase: {
        success: 'Optimización de base de datos completada con éxito',
        error: 'Error durante la optimización de la base de datos',
        loading: 'Optimizando base de datos...'
      },
      rolloverLogs: {
        success: 'Rotación de registros completada con éxito',
        loading: 'Rotando registros...'
      },
      searchLogs: {
        success: 'Búsqueda de registros completada',
        loading: 'Buscando registros...'
      },
      runDiagnostics: {
        success: 'Diagnósticos completados con éxito',
        loading: 'Ejecutando diagnósticos...'
      },
      runSecurityScan: {
        success: 'Escaneo de seguridad completado con éxito',
        loading: 'Ejecutando escaneo de seguridad...'
      },
      cancel: 'Cancelar',
      save: 'Guardar Cambios'
    },
    userManagementSection: {
      totalUsers: 'Usuarios Totales',
      newUsers: 'Nuevos Usuarios (Mes)',
      searchUsers: 'Buscar usuarios...',
      clearSearch: 'Limpiar búsqueda',
      search: 'Buscar',
      usersFound: 'usuarios encontrados',
      showAllUsers: 'Mostrar Todos los Usuarios',
      searching: 'Buscando...',
      searchingUsers: 'Buscando usuarios...',
      noUsersFound: 'No se encontraron usuarios que coincidan con sus criterios de búsqueda.',
      noUsers: 'No hay usuarios disponibles.',
      showing: 'Mostrando',
      of: 'de',
      previous: 'Anterior',
      next: 'Siguiente',
      searchFields: {
        all: 'Todos los Campos',
        name: 'Nombre',
        email: 'Correo Electrónico',
        role: 'Rol'
      },
      userSearch: {
        resultsFound: 'Encontrados {total} usuarios coincidentes con "{term}"',
        error: 'Error buscando usuarios'
      }
    },
    logsSection: {
      errorLogs: 'Registros de Errores',
      warningLogs: 'Registros de Advertencias',
      noErrorLogs: 'No se registraron registros de errores hoy.',
      noWarningLogs: 'No se registraron registros de advertencias hoy.',
      infoLogsNote: 'Los registros de información no se muestran en el resumen. Use la función de búsqueda para ver todos los tipos de registros.',
      searchResults: 'Resultados de Búsqueda Más Recientes',
      entriesFound: 'entradas encontradas',
      viewAllResults: 'Ver Todos los Resultados',
      logType: 'Tipo',
      logCount: 'Conteo',
      logTypes: {
        connectionTimeout: 'Tiempo de conexión agotado',
        databaseFailed: 'Consulta de base de datos fallida',
        authFailed: 'Fallo de autenticación',
        lowDiskSpace: 'Espacio en disco por debajo del umbral',
        slowQuery: 'Rendimiento de consulta lenta',
        rateLimit: 'Límite de tasa acercándose'
      },
      logSearch: {
        noResultsFound: 'No se encontraron registros que coincidan con sus criterios de búsqueda',
        resultsFound: 'Encontradas {count} entradas de registro'
      }
    },
    security: {
      title: 'Monitoreo de Seguridad',
      securityScan: 'Escaneo de Seguridad',
      runningSecurityScan: 'Ejecutando Escaneo...',
      lastSecurityScan: 'Último Escaneo de Seguridad',
      vulnerabilitiesFound: 'Vulnerabilidades Encontradas',
      daysAgo: 'días atrás',
      critical: 'crítico',
      medium: 'medio',
      low: 'bajo',
      failedLoginAttempts: 'Intentos de Inicio de Sesión Fallidos (24h)',
      suspiciousActivities: 'Actividades Sospechosas (24h)',
      securityRecommendations: 'Recomendaciones de Seguridad',
      criticalVulnerabilities: 'Vulnerabilidades Críticas',
      mediumVulnerabilities: 'Vulnerabilidades Medias',
      lowVulnerabilities: 'Vulnerabilidades Bajas',
      authenticationIssues: 'Problemas de Autenticación',
      suspiciousActivityLogs: 'Registros de Actividades Sospechosas',
      securityProbeAttempts: 'Intentos de Sondas de Seguridad Detectados',
      sensitiveFileAccess: 'intentos de acceso a archivos o endpoints sensibles detectados',
      envFileAccess: 'Intentos de Acceso a Archivos de Entorno',
      envFileAccessDesc: 'intentos de acceso a archivos .env detectados',
      gitRepoAccess: 'Intentos de Acceso a Repositorio Git',
      gitRepoAccessDesc: 'intentos de acceso a archivos de repositorio Git detectados',
      recommendedAction: 'Acción Recomendada',
      rateLimitRecommendation: 'Considere implementar límites de tasa, bloqueo de IP para infractores persistentes y asegúrese de que el endurecimiento del servidor esté en su lugar.',
      envFileRecommendation: 'Asegúrese de que los archivos de entorno no sean accesibles desde directorios web y que las configuraciones del servidor bloqueen adecuadamente el acceso a archivos sensibles.',
      gitRepoRecommendation: 'Asegúrese de que los directorios .git estén debidamente asegurados y no accesibles desde la web.',
      noVulnerabilitiesFound: 'No se Encontraron Vulnerabilidades',
      systemSecure: 'Su sistema parece ser seguro. Continúe monitoreando regularmente.',
      loadingScan: 'Cargando resultados de escaneo...',
      occurrences: 'Ocurrencias',
      firstSeen: 'Visto por Primera Vez',
      lastSeen: 'Visto por Última Vez',
      timestamp: 'Marca de Tiempo',
      message: 'Mensaje',
      service: 'Servicio',
      type: 'Tipo',
      severity: 'Severidad',
      url: 'URL',
      matchedTerm: 'Término Coincidente',
      lineNumber: 'Número de Línea',
      lineNumbers: 'Números de Línea',
      showLess: 'Mostrar Menos',
      showMore: 'Mostrar Todos los Problemas',
      // --- NEW KEY ---
      lastScanJustNow: "Justo ahora"
    },
    userEdit: {
      title: 'Editar Usuario',
      loading: 'Cargando datos del usuario...',
      userInfo: 'Información del Usuario',
      userId: 'ID de Usuario',
      loginName: 'Nombre de Inicio de Sesión',
      fullName: 'Nombre Completo',
      dob: 'Fecha de Nacimiento',
      email: 'Correo Electrónico',
      emailVerified: 'Correo Electrónico Verificado',
      verified: 'Verificado',
      notVerified: 'No Verificado',
      createdAt: 'Creado',
      lastLogin: 'Último Inicio de Sesión',
      never: 'Nunca',
      accountSettings: 'Configuraciones de Cuenta',
      accountStatus: 'Estado de Cuenta',
      accountEnabled: 'Cuenta Habilitada',
      cannotDisableSelf: 'No puede deshabilitar su propia cuenta',
      accountRole: 'Rol de Cuenta',
      adminRole: 'Rol de Administrador',
      cannotChangeOwnRole: 'No puede cambiar su propio rol',
      adminActions: 'Acciones de Administrador',
      verifyEmail: 'Verificar Correo Electrónico',
      resetPassword: 'Enviar Restablecimiento de Contraseña',
      forceLogout: 'Forzar Cierre de Sesión',
      failedToLoad: 'Falló la carga de datos del usuario',
      errorLoading: 'Error cargando datos del usuario',
      saveSuccess: 'Configuraciones de usuario actualizadas con éxito',
      errorSaving: 'Error guardando configuraciones de usuario',
      verifyEmailSuccess: 'Correo de verificación enviado con éxito',
      emailVerificationFailed: 'Falló el envío de correo de verificación',
      errorVerifyingEmail: 'Error enviando correo de verificación',
      passwordResetSent: 'Correo de restablecimiento de contraseña enviado',
      passwordResetFailed: 'Falló el envío de restablecimiento de contraseña',
      errorSendingReset: 'Error enviando restablecimiento de contraseña',
      logoutForced: 'El usuario ha sido desconectado',
      logoutFailed: 'Falló el forzado de cierre de sesión',
      errorForcingLogout: 'Error forzando cierre de sesión',
      // --- NEW KEY ---
      userUpdated: "Usuario actualizado correctamente"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: 'Gestión de la Jerarquía de Conocimiento (nota: siempre en inglés - añadir traducciones)',
      addCategory: 'Añadir Nueva Categoría',
      loading: 'Cargando Jerarquía...',
      addService: 'Añadir Servicio',
      editCategory: 'Editar Categoría',
      deleteCategory: 'Eliminar Categoría',
      editService: 'Editar Servicio',
      deleteService: 'Eliminar Servicio',
      empty: 'No se encontraron categorías. Haga clic en "Añadir Nueva Categoría" para comenzar.',
      formTitleCreateCategory: 'Crear Nueva Categoría',
      formTitleAddService: 'Añadir Servicio a "{categoryName}"',
      formTitleEditCategory: 'Editar Categoría: "{itemName}"',
      formTitleEditService: 'Editar Servicio: "{itemName}"',
      nameEnLabel: 'Nombre (Inglés)',
      translationsTitle: 'Traducciones para Visualización',
      loadingTranslations: 'Cargando traducciones...',
      selectLang: 'Seleccionar Idioma',
      translationPlaceholder: 'Introducir traducción',
      deleteTranslation: 'Eliminar Traducción',
      addTranslation: '+ Añadir Traducción',
      saveSuccess: 'Elemento de jerarquía guardado correctamente.',
      saveError: 'Error al guardar el elemento de jerarquía.',
      loadError: 'Error al cargar la jerarquía de conocimiento.',
      loadTranslationsError: 'Error al cargar las traducciones.',
      confirmCancelTitle: 'Cambios no guardados',
      confirmCancelEdit: 'Tiene cambios no guardados que se perderán. ¿Está seguro de que desea cambiar de pestaña?',
      confirmDeleteTitleCategory: '¿Eliminar Categoría?',
      confirmDeleteTitleService: '¿Eliminar Servicio?',
      confirmDeleteCategory: '¿Está seguro de que desea eliminar la Categoría "{itemName}"? Esta acción no se puede deshacer.',
      confirmDeleteService: '¿Está seguro de que desea eliminar el Servicio "{itemName}"? Esta acción no se puede deshacer.',
      deleteSuccessCategory: 'Categoría eliminada correctamente.',
      deleteSuccessService: 'Servicio eliminado correctamente.',
      deleteErrorCategory: 'Error al eliminar la Categoría.',
      deleteErrorService: 'Error al eliminar el Servicio.',
      duplicateLangError: 'Se encontraron idiomas duplicados en las traducciones. Por favor, elimínelos.'
    },
    // --- NEW OBJECT ---
    documents: {
      title: 'Gestión de Documentos',
      addLink: 'Añadir desde Enlace',
      uploadFiles: 'Subir Archivos',
      searchPlaceholder: 'Buscar por nombre de archivo...',
      allStatuses: 'Todos los Estados',
      statusPending: 'Pendiente',
      statusIngested: 'Ingerido',
      statusRetracted: 'Retractado',
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Ingiriendo",
      statusError: "Error de Ingestión",
      statusWarning: "Ingerido con Advertencias",
      // ---
      ingestSelected: 'Ingerir Seleccionados',
      colFileName: 'Nombre de Archivo',
      colStatus: 'Estado',
      colLabels: 'Etiquetas',
      colUploadDate: 'Fecha de Subida',
      colSize: 'Tamaño',
      loading: 'Cargando documentos...',
      empty: 'No se encontraron documentos.',
      loadError: 'Error al cargar documentos.',
      confirmIngestTitle: 'Confirmar Ingestión por Lotes',
      ingest: 'Ingerir',
      confirmIngestSelected: '¿Está seguro de que desea ingerir {count} archivo(s) seleccionado(s)?',
      ingestQueuedSuccess: '{count} archivo(s) ha(n) sido puesto(s) en cola para ingestión.',
      ingestQueuedError: 'Ocurrió un error durante el proceso de ingestión por lotes.',
      uploadSuccessMultiple: '{count} archivo(s) subido(s) correctamente.',
      linkSubmitSuccess: 'Se ha rastreado y guardado "{fileName}" correctamente.',
      actionSuccess: 'La acción "{action}" en el archivo {fileId} fue exitosa.',
      metadataUpdateSuccess: 'Los metadatos del archivo {fileId} se actualizaron.'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Crear Nueva Contraseña',
    tokenLabel: 'Token de Restablecimiento',
    tokenPlaceholder: 'Ingrese el token de restablecimiento',
    validateButton: 'Validar Token',
    newPasswordLabel: 'Nueva Contraseña',
    newPasswordPlaceholder: 'Cree una nueva contraseña',
    confirmNewPasswordLabel: 'Confirmar Nueva Contraseña',
    confirmNewPasswordPlaceholder: 'Confirme su nueva contraseña',
    resetButton: 'Restablecer Contraseña',
    processing: 'Restableciendo...',
    rememberedPassword: '¿Recordó su contraseña?',
    backToLogin: 'Volver a Iniciar Sesión',
    supportMessage: '¿Necesita ayuda? Contacte a nuestro equipo de soporte',
    passwordRequirements: 'La contraseña debe tener al menos 8 caracteres con al menos 1 número, 1 letra mayúscula y 1 carácter especial',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    resetSuccess: 'Su contraseña ha sido restablecida con éxito',
    resetFailed: 'No se pudo restablecer la contraseña. Por favor, intente nuevamente.',
    noTokenProvided: 'Por favor, proporcione un token de restablecimiento',
    expiredToken: 'Este token de restablecimiento ha expirado. Por favor, solicite uno nuevo.',
    invalidToken: 'Token de restablecimiento inválido o no reconocido',
    validatingToken: 'Validando token...',
    redirecting: 'Redirigiendo a la página de inicio de sesión...',
    passwordStrength: 'Fortaleza de la Contraseña',
    strengthLabels: {
      veryWeak: 'Muy Débil',
      weak: 'Débil',
      fair: 'Aceptable',
      good: 'Buena',
      strong: 'Fuerte'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Use al menos 8 caracteres',
      addUppercase: 'Agregue letras mayúsculas',
      addLowercase: 'Agregue letras minúsculas',
      addNumbers: 'Agregue números',
      addSpecialChars: 'Agregue caracteres especiales'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Restablecer Su Contraseña',
    emailLabel: 'Dirección de Correo Electrónico',
    emailPlaceholder: 'Ingrese su correo electrónico',
    resetButton: 'Enviar Enlace de Restablecimiento',
    processing: 'Enviando...',
    rememberPassword: '¿Recordó su contraseña?',
    backToLogin: 'Volver a Iniciar Sesión',
    supportMessage: '¿Necesita ayuda? Contacte a nuestro equipo de soporte',
    invalidEmail: 'Por favor, ingrese una dirección de correo electrónico válida',
    resetRequestSuccess: 'El enlace de restablecimiento de contraseña ha sido enviado a su correo electrónico',
    resetRequestFailed: 'No se pudo enviar el enlace de restablecimiento de contraseña. Por favor, intente nuevamente.',
    checkEmail: 'Por favor, revise su correo electrónico para obtener más instrucciones.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Crear Nueva Cuenta",
    username: "Nombre de Usuario",
    usernamePlaceholder: "Ingrese un nombre de usuario",
    email: "Correo Electrónico",
    emailPlaceholder: "Ingrese su correo electrónico",
    password: "Contraseña",
    passwordPlaceholder: "Cree una contraseña",
    confirmPassword: "Confirmar Contraseña",
    confirmPasswordPlaceholder: "Confirme su contraseña",
    acceptTerms: "Acepto los",
    termsOfService: "Términos de Servicio",
    registerButton: "Crear Cuenta",
    processing: "Procesando...",
    alreadyHaveAccount: "¿Ya tiene una cuenta?",
    loginNow: "Inicie sesión",
    privacyNotice: "Al registrarse, acepta nuestros Términos de Servicio y Política de Privacidad",
    usernameMinLength: "El nombre de usuario debe tener al menos 3 caracteres",
    invalidEmail: "Por favor, ingrese una dirección de correo electrónico válida",
    passwordRequirements: "La contraseña debe tener al menos 8 caracteres con al menos 1 número y 1 letra mayúscula",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    mustAcceptTerms: "Debe aceptar los Términos de Servicio",
    registrationFailed: "Registro fallido. Por favor, intente nuevamente.",
    usernameExists: "El nombre de usuario ya existe",
    emailExists: "El correo electrónico ya existe",
    registrationSuccess: "¡Registro Exitoso!",
    verificationEmailSent: "Se ha enviado un correo de verificación a {email}",
    checkEmailInstructions: "Por favor, revise su correo electrónico y siga las instrucciones para verificar su cuenta antes de iniciar sesión.",
    backToLogin: "Volver a Iniciar Sesión",
    noEmailReceived: "¿No recibió un correo electrónico?",
    resendVerification: "Reenviar correo de verificación",
    verificationResent: "Correo de verificación reenviado",
    verificationResendFailed: "Falló el reenvío del correo de verificación. Por favor, intente nuevamente.",
    usernameInvalidChars: 'El nombre de usuario solo puede contener letras, números, guiones bajos, puntos y guiones',
    networkError: 'Error de red. Por favor, verifique su conexión e intente nuevamente.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Nombre de Usuario',
    password: 'Contraseña',
    loginButton: 'Iniciar Sesión',
    or: 'o',
    savedAccounts: 'Cuentas GuardADAS',
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Inicio de sesión fallido. Por favor, verifique sus credenciales.',
    googleLogin: 'Continuar con Google',
    facebookLogin: 'Continuar con Facebook',
    rememberMe: 'Recordarme',
    forgotPassword: '¿Olvidó su contraseña?',
    noAccount: '¿No tiene una cuenta?',
    createAccount: 'Crear cuenta',
    registerNow: "Regístrese ahora",
    termsAndPolicy: 'Al iniciar sesión, acepta nuestros Términos de Servicio y Política de Privacidad',
    loggingIn: "Iniciando sesión...",
    fieldsRequired: "Nombre de usuario y contraseña son requeridos",
    invalidCredentials: "Nombre de usuario o contraseña inválidos",
    tooManyAttempts: "Demasiados intentos de inicio de sesión. Por favor, intente nuevamente más tarde.",
    loginFailed: "Inicio de sesión fallido. Por favor, intente nuevamente.",
    oauthNotImplemented: "El inicio de sesión social aún no está implementado",
    savedLoginNotImplemented: "El inicio de sesión con cuenta guardada aún no está implementado"
  },
  charts: {
    tooltip: {
      title: 'Fecha',
      totalQueries: 'Consultas Totales',
      uniqueUsers: 'Usuarios Únicos'
    },
    day: 'Día',
    noData: 'Sin Datos',
    notAvailable: 'N/D',
    topQueries: 'Consultas Principales',
    categoryDistribution: 'Uso por Área de Conocimiento',
    usageTrend: 'Tendencia de Uso'
  },
  analytics: {
    title: 'Análisis de Datos e Insights',
    loading: 'Cargando datos de análisis...',
    period: 'Período de Tiempo',
    charts: {
      satisfactionHeatmap: "Satisfacción por Área de Conocimiento",
      satisfactionSubtitle: "Porcentajes de puntuación a lo largo del tiempo"
    },
    timePeriods: {
      week4: "Hace 4 Semanas",
      week3: "Hace 3 Semanas",
      week2: "Hace 2 Semanas",
      week1: "Semana Pasada",
      current: "Actual"
    },
    errors: {
      loading: "Falló la carga de datos de satisfacción. Por favor, intente nuevamente.",
    },
    status: {
      loading: 'Cargando...',
      noData: 'No hay datos disponibles para este período',
      error: 'Falló la carga de datos de análisis',
      online: "Sistema en Línea",
      offline: "Sistema Fuera de Línea",
      responseTime: "Tiempo de Respuesta Promedio",
      queueLength: "Cola",
      uptime: "Tiempo de Actividad"
    },
    periods: {
      daily: 'Diario',
      weekly: 'Semanal',
      monthly: 'Mensual',
      allTime: 'Todo el Tiempo'
    },
    metrics: {
      totalQueries: 'Consultas Totales',
      uniqueUsers: 'Usuarios Únicos',
      avgResponseTime: 'Tiempo de Respuesta Promedio',
      satisfaction: 'Satisfacción del Usuario'
    },
    table: {
      rank: 'Rango',
      query: 'Consulta',
      count: 'Conteo',
      avgTime: 'Tiempo Promedio'
    },
    chartLabels: {
      categories: 'Áreas',
      serviceCategories: 'Áreas de Conocimiento',
      byUsage: 'por Uso',
      category: 'Área'
    },
    tooltips: {
      selectPeriod: 'Seleccionar período de tiempo',
      selectDate: 'Seleccionar fecha',
      exportData: 'Exportar datos'
    },
    gauge: {
      historical: 'Tendencias Históricas',
      vsPrevious: 'vs período anterior',
      target: 'Objetivo'
    },
    ratings: {
      poor: "Pobre",
      average: "Promedio",
      good: "Bueno",
      excellent: "Excelente"
    },
    slower: 'más lento',
    faster: 'más rápido',
    percentage: 'Porcentaje',
    note: 'A continuación se muestran estadísticas de uso y resúmenes de retroalimentación de usuarios.',
    usageStats: 'Estadísticas de Uso',
    peakUsers: 'Usuarios Concurrentes Máximos',
    activeChats: 'Chats Activos',
    usageTrend: 'Tendencia de Uso',
    topQueries: 'Consultas Principales',
    feedbackSamples: 'Muestras de Retroalimentación de Usuarios',
    close: 'Cerrar',
    chartComingSoon: 'Visualización de gráfico interactivo próximamente...',
    retry: 'Reintentar',
    dailyQueries: 'Consultas Diarias',
    export: 'Exportar Datos',
    dateRange: 'Rango de Fechas',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    rank: 'Rango',
    query: 'Consulta',
    count: 'Conteo',
    avgTime: 'Tiempo Promedio',
    serviceUsage: 'Uso por Área de Conocimiento',
    usageTrends: 'Tendencias de Uso',
    week: 'Semana Pasada',
    month: 'Mes Pasado',
    quarter: 'Trimestre Pasado',
    year: 'Año Pasado',
    uniqueUsers: 'Usuarios Únicos',
    satisfactionRate: 'Tasa de Satisfacción',
    satisfactionAnalysis: 'Análisis de Satisfacción del Usuario'
  },
  brandName: 'Genie AI: Su Asistente Digital Gubernamental',
  nav: {
    systemStatus: 'Estado del Sistema',
    menu: 'Menú',
    analytics: 'Análisis',
    userProfile: 'Perfil de Usuario',
    settings: 'Configuraciones',
    logout: 'Cerrar Sesión',
    profile: 'Mi Perfil',
    toggleSidebar: 'Alternar barra lateral',
    changeLanguage: 'Cambiar idioma',
    administration: "Administración",
    languages: {
      english: 'Inglés',
      french: 'Francés',
      swahili: 'Suajili'
    }
  },
  systemStatus: {
    title: 'Estado del Servicio',
    services: 'Servicios',
    operational: 'Operacional',
    degraded: 'Degradado',
    outage: 'Apagón',
    allOperational: 'Todos los Sistemas',
    someIssues: 'Algunos Problemas',
    majorIssues: 'Problemas Mayores',
    checking: 'Verificando...',
    nextDeadline: 'Próximo Plazo',
    days: 'días',
    viewDetails: 'Ver Detalles'
  },
  services: {
    eCitizen: 'Portal eCitizen',
    taxFiling: 'Sistema de Presentación de Impuestos',
    idApplication: 'Solicitud de ID',
    businessReg: 'Registro de Negocios',
    drivingLicense: 'Licencia de Conducir'
  },
  deadlines: {
    taxFiling: 'Plazo para Presentación de Impuestos',
    businessRenewal: 'Renovación de Licencia de Negocios',
    idRenewal: 'Renovación de Tarjeta de ID',
    vehicleRegistration: 'Plazo para Registro de Vehículos'
  },
  sidebar: {
    governmentServices: 'Áreas de Conocimiento',
    chatHistory: 'Historial de Chat',
    searchPlaceholder: 'Buscar áreas de conocimiento...',
    createFolder: 'Crear Carpeta',
    editFolder: 'Editar Carpeta',
    folderName: 'Nombre de Carpeta',
    folderNamePlaceholder: 'Ingrese nombre de carpeta',
    moveChat: 'Mover Chat',
    moveChatTo: 'Mover Chat A',
    selectFolder: 'Seleccionar Carpeta',
    deleteChat: 'Eliminar Chat',
    deleteChatConfirm: '¿Está seguro de que desea eliminar este chat?',
    deleteChatWarning: 'Esta acción no se puede deshacer.',
    renameChat: "Renombrar Chat",
    chatTitle: "Título del Chat",
    chatTitlePlaceholder: "Ingrese un título para este chat",
    deleteFolder: "Eliminar Carpeta",
    deleteFolderConfirm: "¿Está seguro de que desea eliminar la carpeta '{name}'?",
    chatsMoveWarning: "Todos los chats en esta carpeta se moverán a la carpeta predeterminada.",
    weatherTitle: "Pronóstico del Tiempo",
    weatherLoading: "Cargando datos del tiempo...",
    weatherError: "No se pudo cargar los datos del tiempo. Por favor, intente nuevamente.",
    weatherLocationLoading: 'Cargando ubicación...',
    weatherErrorDefault: 'No se pueden recuperar los datos del tiempo.',
    weatherGeolocationUnsupported: 'La geolocalización no es compatible con su navegador.',
    weatherRefresh: 'Actualizar Tiempo',
    weatherConditions: {
      clear: 'Despejado',
      partlycloudy: 'Parcialmente nublado',
      cloudy: 'Nublado',
      overcast: 'Cubierto',
      rain: 'Lluvia',
      shower: 'Chubascos',
      thunderstorm: 'Tormenta',
      snow: 'Nieve'
    },
    folders: "Carpetas",
    emptyFolder: "Esta carpeta está vacía. Mueva conversaciones aquí desde el menú de chat.",
    title: 'Información y Recursos',
    noChats: 'No hay chats recientes',
    relatedDocs: 'Documentos Relacionados',
    noDocuments: 'No hay documentos relacionados',
    faq: 'Preguntas Frecuentes',
    tab: {
      all: 'Todos los Chats',
      folders: 'Carpetas',
      starred: 'Destacados',
      archived: 'Archivados'
    },
    savedChats: 'Chats Guardados',
    chats: "Chats",
    allChats: "Todos los Chats",
    noFolder: "Sin Carpeta",
    starredChats: "Chats Destacados",
    archivedChats: "Chats Archivados",
    noStarredChats: "No hay conversaciones destacadas aún. Destaque una conversación para agregarla aquí.",
    noArchivedChats: "No hay conversaciones archivadas aún.",
    noSearchResults: 'No se encontraron conversaciones para "{term}"',
    loadingChats: "Cargando conversaciones...",
    errorLoadingConversations: "Falló la carga de conversaciones. Por favor, intente nuevamente.",
    errorLoadingUser: "Los datos del usuario están incompletos. Por favor, recargue la página.",
    errorNoUser: "Faltan datos del usuario. Por favor, recargue la página.",
    retry: "Reintentar",
    message: "mensaje",
    messages: "mensajes",
    created: "Creado",
    updated: "Actualizado",
    star: "Destacar",
    unstar: "Quitar Destacado",
    archive: "Archivar",
    chatStarred: "Conversación destacada",
    chatUnstarred: "Conversación sin destacar",
    chatArchived: "Conversación archivada",
    chatUnarchived: "Conversación desarchivada",
    errorUpdatingChat: "Falló la actualización de la conversación",
    chatRenamed: "Conversación renombrada con éxito",
    errorRenamingChat: "Falló el renombrado de la conversación",
    chatDeleted: "Conversación eliminada con éxito",
    errorDeletingChat: "Falló la eliminación de la conversación",
    chatMoved: "Conversación movida con éxito",
    errorMovingChat: "Falló el movimiento de la conversación",
    noPreview: "No hay vista previa disponible",
    searchConversations: 'Buscar conversaciones...',
    selectFolderInstruction: "Seleccione una carpeta para ver sus conversaciones",
    folderCreated: "Carpeta creada con éxito",
    errorCreatingFolder: "Falló la creación de la carpeta",
    errorLoadingFolders: "Falló la carga de carpetas",
    folderUpdated: "Carpeta actualizada con éxito",
    errorUpdatingFolder: "Falló la actualización de la carpeta",
    folderDeleted: "Carpeta eliminada con éxito",
    errorDeletingFolder: "Falló la eliminación de la carpeta",
    chatRemovedFromFolders: "Conversación eliminada de la carpeta",
    errorRemovingChat: "Falló la eliminación de la conversación de la carpeta",
    id: "ID",
    labels: "Etiquetas",
    confidence: "Confianza",
    unknown: "Desconocido"
  },
  leftPanel: {
    cat1: {
      name: '1. Identidad y Registro Civil',
      children: ['Certificados de nacimiento', 'Tarjetas de ID nacional', 'Pasaportes', 'Certificados de matrimonio y defunción', 'Registro de votantes']
    },
    cat2: {
      name: '2. Salud y Servicios Sociales',
      children: ['Acceso a salud pública', 'Programas de vacunación', 'Seguro de salud', 'Beneficios por discapacidad', 'Asistencia social y alimentaria']
    },
    cat3: {
      name: '3. Educación y Aprendizaje',
      children: ['Escuelas públicas y universidades', 'Becas y préstamos estudiantiles', 'Programas de educación para adultos', 'Recursos de aprendizaje en línea']
    },
    cat4: {
      name: '4. Empleo y Servicios Laborales',
      children: ['Búsqueda de empleo y beneficios por desempleo', 'Protecciones laborales y derechos de los trabajadores', 'Regulaciones de seguridad en el trabajo', 'Entrenamiento de habilidades y aprendizajes']
    },
    cat5: {
      name: '5. Impuestos y Ingresos',
      children: ['Presentación de impuestos sobre la renta y reembolsos', 'Pagos de impuestos sobre la propiedad', 'Cumplimiento fiscal empresarial', 'Aduanas y derechos de importación']
    },
    cat6: {
      name: '6. Seguridad Pública y Justicia',
      children: ['Policía y servicios de emergencia', 'Tribunales y servicios de ayuda legal', 'Reporte de crímenes', 'Leyes de protección al consumidor']
    },
    cat7: {
      name: '7. Transporte y Movilidad',
      children: ["Licencias de conducir y registro de vehículos", 'Transporte público e infraestructura', 'Violaciones de tráfico y multas', 'Programas de seguridad vial']
    },
    cat8: {
      name: '8. Vivienda y Desarrollo Urbano',
      children: ['Asistencia para vivienda pública', 'Registro de propiedades y registros de tierras', 'Préstamos y subsidios para vivienda', 'Zonificación y permisos de construcción']
    },
    cat9: {
      name: '9. Servicios Públicos y Medio Ambiente',
      children: ['Servicios de agua y electricidad', 'Gestión de residuos y reciclaje', 'Regulaciones ambientales', 'Iniciativas de energía renovable']
    },
    cat10: {
      name: '10. Negocios y Comercio',
      children: ['Registro y licencias de negocios', 'Regulaciones y permisos comerciales', 'Subvenciones e incentivos para pequeñas empresas', 'Soporte para e-commerce y negocios digitales']
    },
    cat11: {
      name: '11. Seguridad Social y Pensiones',
      children: ['Beneficios de jubilación', 'Gestión de fondos de pensiones', 'Beneficios para sobrevivientes', 'Pensiones por discapacidad']
    },
    cat12: {
      name: '12. Comunidad y Participación Cívica',
      children: ['Votación y elecciones', 'Retroalimentación pública y quejas ciudadanas', 'Voluntariado y programas comunitarios', 'Participación en gobierno local']
    }
  },
  settings: {
    title: 'Configuraciones',
    save: 'Guardar',
    close: 'Cerrar',
    saveSettings: 'Guardar Configuraciones',
    savingSettings: "Guardando sus configuraciones...",
    settingsSaved: "¡Configuraciones guardadas con éxito!",
    saveSuccess: 'Configuraciones guardadas con éxito',
    saveError: 'Error guardando configuraciones',
    display: 'Pantalla',
    displayLanguage: 'Idioma de Pantalla',
    languages: {
      english: 'Inglés',
      french: 'Francés',
      swahili: 'Suajili'
    },
    theme: 'Tema',
    themes: {
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Sistema'
    },
    fontSize: 'Tamaño de Fuente',
    notifications: 'Notificaciones',
    emailUpdates: 'Actualizaciones por correo electrónico',
    soundNotifications: 'Notificaciones de sonido',
    accountManagement: 'Gestión de Cuenta',
    emailAddress: 'Dirección de Correo Electrónico',
    emailAddressPlaceholder: 'Su dirección de correo electrónico',
    password: 'Contraseña',
    changePassword: 'Cambiar Contraseña',
    resetUserData: 'Restablecer Datos de Usuario',
    resetUserDataDesc: 'Esto borrará todos sus datos de perfil e historial de chat.',
    deleteAccount: 'Eliminar Cuenta',
    deleteAccountDesc: 'Esto eliminará permanentemente su cuenta y todos los datos asociados.',
    edit: 'Editar',
    standardAccount: 'Cuenta Estándar',
    confirmEmailChange: 'Confirmar Cambio de Correo Electrónico',
    pleaseEnterPassword: 'Por favor, ingrese su contraseña',
    cancel: 'Cancelar',
    account: {
      title: 'Cuenta',
      resetDescription: 'Esto borrará todos sus datos de perfil e historial de chat.',
      confirmReset: '¿Está seguro de que desea restablecer todos sus datos? Esto no se puede deshacer.',
      resetComplete: 'Sus datos han sido restablecidos.'
    },
    language: {
      title: 'Idioma',
      selectLabel: 'Idioma de Pantalla'
    },
    appearance: {
      title: 'Apariencia',
      lightTheme: 'Claro',
      darkTheme: 'Oscuro',
      systemTheme: 'Sistema'
    },
    confirmDeleteAccount: '¿Está seguro de que desea eliminar su cuenta? Esta acción no se puede deshacer.',
    confirmAccountDeletion: 'Confirmar Eliminación de Cuenta',
    accountDeletionWarning: 'Advertencia: Esta acción es permanente y no se puede deshacer. Todos sus datos serán eliminados permanentemente.',
    deletionReason: 'Motivo de eliminación (opcional):',
    deletionReasonPlaceholder: '¿Qué le hizo decidir eliminar su cuenta?',
    enterPasswordConfirm: 'Ingrese su contraseña para confirmar:',
    currentPasswordPlaceholder: 'Su contraseña actual',
    deleting: 'Eliminando...',
    permanentlyDeleteAccount: 'Eliminar Cuenta',
    accountDeletedSuccess: 'Su cuenta ha sido eliminada con éxito.',
    incorrectPassword: 'Contraseña incorrecta',
    accountDeletionFailed: 'Falló la eliminación de la cuenta. Por favor, intente nuevamente más tarde.',
    confirmChange: 'Confirmar Cambio',
    processing: 'Procesando...',
    userDataReset: 'Sus datos de perfil han sido restablecidos con éxito.',
    failedToResetUserData: 'Falló el restablecimiento de sus datos de perfil. Por favor, intente nuevamente más tarde.',
    changingEmailTo: 'Cambiando su correo electrónico a',
    will: 'lo hará',
    logOutSystem: 'Cerrar sesión en el sistema',
    sendVerificationLink: 'Enviar un enlace de verificación a su nuevo correo electrónico',
    requireVerification: 'Requerir verificación antes de poder iniciar sesión nuevamente',
    checkNewEmailVerification: 'Por favor, revise su nuevo correo electrónico para obtener instrucciones de verificación.',
    unableToVerifyEmail: 'No se pudo verificar el correo electrónico. Por favor, intente nuevamente.',
    emailAlreadyInUse: 'Correo electrónico ya en uso',
    enterValidEmail: 'Por favor, ingrese una dirección de correo electrónico válida',
    failedToUpdateEmail: 'Falló la actualización del correo electrónico. Por favor, intente nuevamente.',
    passwordResetInitiated: 'Se ha enviado un enlace de restablecimiento de contraseña a su dirección de correo electrónico.',
    unableToLoadUser: 'No se pudo cargar la información del usuario. Por favor, intente nuevamente.',
    retry: 'Reintentar',
    user: 'Usuario',
    loadingUserInfo: 'Cargando información del usuario...',
    resetUserDataTitle: "Restablecer Datos de Usuario",
    confirmResetUserData: "¿Está seguro de que desea restablecer todos sus datos de perfil? Esto borrará toda su información de perfil e historial de chat, pero mantendrá sus credenciales de cuenta.",
    reset: "Restablecer",
    deleteAccountTitle: "Eliminar Cuenta"
  },
  userProfile: {
    title: 'Perfil de Usuario',
    privacyInfo: "Al proporcionar más información, obtendrá respuestas más precisas y significativas del chatbot. Por favor, revise nuestra",
    privacyPolicyLink: 'Política de Privacidad',
    tabComingSoon: 'Esta pestaña está en desarrollo y estará disponible pronto.',
    saveSuccess: 'Perfil guardado con éxito',
    loadError: 'Error cargando datos de perfil',
    saveError: 'Error guardando perfil',
    confirmSaveTitle: "Guardar Perfil",
    confirmSave: "¿Está seguro de que desea guardar estos cambios?",
    confirmCancel: 'Tiene cambios no guardados. ¿Está seguro de que desea cancelar?',
    confirmLeave: '¿Está seguro de que desea salir? Cualquier cambio no guardado se perderá.',
    confirmDiscardChanges: '¿Descartar cambios no guardados?',
    uploadPhoto: 'Subir Foto',
    uploadFile: 'Subir Archivo',
    photoRequirements: 'La foto debe ser clara, reciente y mostrar su rostro completo',
    biometricRequirements: 'Solo se aceptan archivos de datos biométricos oficiales',
    documentUpload: 'Subida de Documento',
    validationTitle: 'Por favor, corrija los siguientes errores:',
    profileIcon: 'Ícono de Perfil',
    change: 'Cambiar',
    chooseProfileIcon: 'Elija un Ícono de Perfil',
    presetIcons: 'Íconos Predeterminados',
    upload: 'Subir',
    initials: 'Iniciales',
    clickToUpload: 'Haga clic para subir',
    useThisImage: 'Usar Esta Imagen',
    useInitials: 'Usar Iniciales',
    tabs: {
      tab1: 'Datos de Identificación Personal',
      tab2: 'Registro Civil y Documentación',
      tab3: 'Información de Dirección y Residencia',
      tab4: 'Documentos de Identidad y Viajes',
      tab5: 'Registros de Salud y Médicos',
      tab6: 'Datos de Empleo y Económicos',
      tab7: 'Registros Educativos y Académicos',
      tab8: 'Datos Financieros y Fiscales',
      tab9: 'Seguridad Social y Bienestar',
      tab10: 'Registros Criminales y Legales',
      tab11: 'Transporte y Movilidad',
      tab12: 'Participación Cívica y Política'
    },
    actions: {
      cancel: 'Cancelar',
      save: 'Guardar Perfil',
      previous: 'Anterior',
      next: 'Siguiente',
      saving: 'Guardando...'
    },
    fields: {
      fullName: 'Nombre completo (incluyendo alias)',
      dob: 'Fecha de nacimiento',
      gender: 'Género',
      nationality: 'Nacionalidad',
      maritalStatus: 'Estado civil',
      photograph: 'Fotografía',
      biometric: 'Huellas digitales / Datos biométricos',
      birthCert: 'Certificado de nacimiento',
      deathCert: 'Certificado de defunción',
      marriageDivorce: 'Registros de matrimonio / divorcio',
      adoption: 'Registros de adopción',
      citizenship: 'Documentos de ciudadanía / naturalización',
      immigration: 'Historia de inmigración y visa',
      currentAddress: 'Dirección residencial actual',
      previousAddresses: 'Direcciones anteriores',
      postalCode: 'Código Postal',
      country: 'País',
      residencyStatus: 'Estado de Residencia',
      homeOrRental: 'Propiedad o detalles de alquiler',
      utilityBills: 'Facturas de servicios públicos vinculadas a la dirección',
      landRecords: 'Registros de tierras y propiedad',
      idCard: 'Número de tarjeta de ID nacional',
      passport: 'Detalles de pasaporte',
      driversLicense: "Licencia de conducir",
      voterId: 'ID de votante',
      ssn: 'Número de Seguridad Social / Seguro Nacional',
      militaryRecords: 'Registros de servicio militar',
      medicalHistory: 'Historia médica y condiciones de salud',
      vaccinations: 'Registros de vacunación',
      insuranceDetails: 'Detalles de seguro de salud',
      disability: 'Estado de discapacidad',
      bloodType: 'Tipo de Sangre',
      organDonor: 'Estado de donante de órganos',
      prescriptions: 'Recetas y tratamientos recibidos',
      mentalHealth: 'Historia de salud mental',
      eHistory: 'Historia de empleo',
      currentEmployer: 'Detalles del empleador actual',
      workPermits: 'Permisos de trabajo y contratos laborales',
      certifications: 'Certificaciones y licencias profesionales',
      unemployment: 'Estado de desempleo y beneficios recibidos',
      tin: 'Número de identificación fiscal (TIN)',
      businessAffiliations: 'Propiedad empresarial y afiliaciones a compañías',
      schools: 'Escuelas y universidades atendidas',
      education: 'Educación',
      degrees: 'Diplomas, grados y certificaciones',
      performance: 'Rendimiento académico y puntuaciones de exámenes',
      academicRecords: "Registros Académicos",
      scholarships: 'Becas y ayuda financiera recibida',
      incomeTax: 'Registros de impuestos sobre la renta',
      bankAccounts: 'Cuentas bancarias y financieras',
      propertyTax: 'Pagos de impuestos sobre la propiedad',
      businessTax: 'Presentaciones fiscales empresariales',
      pensionContrib: 'Contribuciones y retiros de pensiones',
      loanAid: 'Registros de préstamos y ayuda gubernamental',
      pensionStatus: 'Estado de pensión y contribuciones',
      childcare: 'Apoyo para cuidado infantil',
      foodAssistance: 'Programas de asistencia alimentaria / bienestar',
      housingAssistance: 'Asistencia para vivienda',
      policeRecords: 'Registros policiales (historia criminal, arrestos, cargos)',
      courtCases: 'Historia de casos judiciales',
      finesPenalties: 'Multas y penalizaciones',
      paroleProbation: 'Estado de libertad condicional o probation',
      citizenshipRevocation: 'Revocación de ciudadanía (si aplica)',
      vehicleReg: 'Detalles de registro de vehículos',
      trafficViolations: 'Violaciones de tráfico y multas',
      licenseHistory: 'Historia de licencia de conducir y endosos',
      publicTransportCard: 'Uso de tarjeta de transporte público',
      voterRegistration: 'Detalles de registro de votantes',
      electionHistory: 'Historia de participación en elecciones',
      partyMembership: 'Membresía en partidos políticos',
      militaryStatus: 'Estado de servicio militar o conscripción',
      publicServiceRoles: 'Roles de servicio público'
    },
    placeholders: {
      fullName: 'Ingrese su nombre legal completo',
      nationality: 'Ingrese su nacionalidad',
      searchCountries: 'Buscar países...',
      selectCountry: 'Seleccione un país',
      searchDisciplines: "Buscar disciplinas...",
      selectDiscipline: "Seleccione una disciplina",
      searchDegrees: "Buscar grados...",
      selectDegree: "Seleccione un grado"
    },
    validation: {
      nameRequired: 'Nombre completo es requerido',
      dobRequired: 'Fecha de nacimiento es requerida',
      dobFuture: 'Fecha de nacimiento no puede ser en el futuro',
      requiredField: '{field} es requerido',
      invalidFormat: 'Formato inválido para {field}',
      futureDate: 'La fecha no puede ser en el futuro',
      invalidSelection: 'Por favor, haga una selección válida',
      passwordLength: 'La contraseña debe tener al menos 8 caracteres',
      matchError: 'Los campos no coinciden'
    },
    errors: {
      savingFailed: 'Falló el guardado del perfil',
      loadingFailed: 'Falló la carga de datos de perfil',
      invalidForm: 'Por favor, complete todos los campos requeridos',
      invalidFileType: 'Tipo de archivo inválido',
      fileTooLarge: 'El archivo es demasiado grande',
      countryLoadError: 'Error cargando países',
      countryUpdateError: 'Error actualizando país'
    },
    notifications: {
      saveSuccess: 'Perfil guardado con éxito',
      saveFailed: 'Falló el guardado del perfil',
      loadSuccess: 'Perfil cargado con éxito',
      loadFailed: 'Falló la carga del perfil',
      fieldRequired: 'Este campo es requerido',
      uploadSuccess: 'Archivo subido con éxito',
      uploadFailed: 'Falló la subida del archivo',
      formChanged: 'Tiene cambios no guardados',
      sessionExpired: 'Su sesión ha expirado, por favor inicie sesión nuevamente',
      profileUpdated: 'Su perfil ha sido actualizado',
      profileIncomplete: 'Su perfil está incompleto'
    },
    instructions: {
      fullNameHelp: 'Ingrese su nombre legal completo como aparece en sus documentos oficiales',
      dobHelp: 'Ingrese su fecha de nacimiento en formato MM/DD/AAAA',
      uploadPhotoHelp: 'Suba una foto reciente. El archivo debe ser JPG, PNG o GIF y menos de 2MB',
      passwordHelp: 'La contraseña debe tener al menos 8 caracteres con una letra mayúscula, un número y un carácter especial',
      documentHelp: 'Formatos aceptados: PDF, JPG, PNG (máx 5MB)',
      requiredFields: 'Los campos marcados con * son requeridos',
      selectFromList: 'Por favor, seleccione una opción de la lista',
      nextTab: 'Continuar a la siguiente sección',
      previousTab: 'Regresar a la sección anterior',
      saveInstructions: 'Haga clic en Guardar para almacenar su información',
      cancelInstructions: 'Haga clic en Cancelar para descartar cambios'
    },
    completionStatus: {
      notStarted: 'No Iniciado',
      inProgress: 'En Progreso',
      complete: 'Completo',
      percentComplete: '{percent}% completo',
      tabsCompleted: '{completed} de {total} secciones completadas',
      tabComplete: '¡Pestaña completada!'
    },
    gender: {
      male: 'Masculino',
      female: 'Femenino',
      other: 'Otro',
      preferNot: 'Prefiero no decir'
    },
    maritalStatus: {
      single: 'Soltero',
      married: 'Casado',
      divorced: 'Divorciado',
      widowed: 'Viudo',
      other: 'Otro'
    },
    residencyStatuses: {
      citizen: 'Ciudadano',
      permanentResident: 'Residente Permanente',
      temporaryResident: 'Residente Temporal',
      other: 'Otro'
    },
    employmentStatuses: {
      employed: 'Empleado',
      selfEmployed: 'Autoempleado',
      unemployed: 'Desempleado',
      student: 'Estudiante',
      retired: 'Jubilado',
      homemaker: 'Ama de Casa',
      other: 'Otro'
    },
    educationLevels: {
      primary: 'Educación Primaria',
      secondary: 'Educación Secundaria',
      highSchool: 'Escuela Secundaria',
      vocational: 'Entrenamiento Vocacional',
      associate: 'Grado Asociado',
      bachelor: 'Licenciatura',
      master: 'Maestría',
      doctoral: 'Doctorado',
      professional: 'Grado Profesional',
      other: 'Otro'
    },
    proficiencyLevels: {
      native: 'Nativo',
      fluent: 'Fluido',
      advanced: 'Avanzado',
      intermediate: 'Intermedio',
      basic: 'Básico'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Desconocido'
    },
    languages: {
      english: 'Inglés',
      french: 'Francés',
      swahili: 'Suajili',
      arabic: 'Árabe',
      spanish: 'Español',
      portuguese: 'Portugués',
      chinese: 'Chino',
      japanese: 'Japonés',
      german: 'Alemán',
      russian: 'Ruso',
      hindi: 'Hindi',
      urdu: 'Urdu',
      other: 'Otro'
    },
    yesNo: {
      yes: 'Sí',
      no: 'No'
    },
    select: 'Por favor, seleccione',
    existingFile: 'Archivo existente',
    noMatchingCountries: 'No se encontraron países coincidentes',
    noMatchingDisciplines: "No se encontraron disciplinas coincidentes",
    noMatchingDegrees: "No se encontraron grados coincidentes",
    educationOptions: [
      "Contabilidad", "Ingeniería Aeroespacial", "Ciencia Agrícola", "Antropología", "Arquitectura",
      "Historia del Arte", "Inteligencia Artificial", "Astronomía", "Astrofísica", "Bioquímica",
      "Ingeniería Biomédica", "Biotecnología", "Administración de Empresas", "Ingeniería Química",
      "Química", "Ingeniería Civil", "Comunicaciones", "Ingeniería Informática", "Ciencia de la Computación",
      "Gestión de Construcción", "Justicia Criminal", "Ciberseguridad", "Ciencia de Datos", "Odontología",
      "Economía", "Educación", "Ingeniería Eléctrica", "Educación Primaria", "Literatura Inglesa",
      "Ingeniería Ambiental", "Ciencia Ambiental", "Diseño de Moda", "Estudios Cinematográficos",
      "Finanzas", "Bellas Artes", "Ciencia de los Alimentos", "Ciencia Forense", "Diseño de Juegos",
      "Geografía", "Geología", "Diseño Gráfico", "Administración de Salud", "Historia",
      "Gestión Hotelera", "Recursos Humanos", "Diseño Industrial", "Ingeniería Industrial", "Sistemas de Información",
      "Tecnología de la Información", "Diseño de Interiores", "Negocios Internacionales", "Relaciones Internacionales",
      "Periodismo", "Derecho", "Biblioteconomía", "Lingüística", "Gestión", "Marketing",
      "Ciencia de Materiales", "Matemáticas", "Ingeniería Mecánica", "Estudios de Medios", "Medicina",
      "Meteorología", "Microbiología", "Música", "Nanotecnología", "Enfermería", "Nutrición",
      "Terapia Ocupacional", "Oceanografía", "Ingeniería Petrolera", "Farmacia", "Filosofía",
      "Fotografía", "Educación Física", "Terapia Física", "Física", "Ciencia Política",
      "Psicología", "Administración Pública", "Salud Pública", "Relaciones Públicas", "Robótica",
      "Educación Secundaria", "Trabajo Social", "Sociología", "Ingeniería de Software", "Educación Especial",
      "Gestión Deportiva", "Estadística", "Ingeniería de Sistemas", "Artes Teatrales", "Turismo",
      "Planificación Urbana", "Medicina Veterinaria", "Desarrollo Web", "Biología de la Fauna", "Zoología"
    ],
    degreeOptions: [
      "Grado Asociado", "Licenciatura en Artes (BA)", "Licenciatura en Ciencias (BS)", "Licenciatura en Ingeniería (BEng)",
      "Licenciatura en Administración de Empresas (BBA)", "Licenciatura en Bellas Artes (BFA)", "Licenciatura en Educación (BEd)",
      "Licenciatura en Medicina (MBBS)", "Licenciatura en Derecho (LLB)", "Maestría en Artes (MA)", "Maestría en Ciencias (MS)",
      "Maestría en Administración de Empresas (MBA)", "Maestría en Ingeniería (MEng)", "Maestría en Bellas Artes (MFA)",
      "Maestría en Educación (MEd)", "Maestría en Derecho (LLM)", "Maestría en Salud Pública (MPH)",
      "Doctorado en Filosofía (PhD)", "Doctorado en Medicina (MD)", "Doctorado en Educación (EdD)",
      "Doctorado en Administración de Empresas (DBA)", "Doctorado en Jurisprudencia (JD)", "Diploma Profesional",
      "Diploma Técnico", "Certificado Vocacional", "Certificado de Posgrado", "Diploma de Posgrado", "Posdoctorado"
    ],
    aria: {
      tabList: 'Secciones del formulario de perfil',
      nextButton: 'Ir a la siguiente sección',
      prevButton: 'Ir a la sección anterior',
      closeButton: 'Cerrar formulario de perfil',
      saveButton: 'Guardar datos de perfil',
      requiredField: 'Campo requerido',
      dropdownSelect: 'Seleccionar una opción'
    }
  },
  chatbot: {
    placeholder: 'Escriba su consulta aquí...',
    sendButton: 'Enviar',
    fileReceived: 'Archivo recibido con éxito.',
    fileUploadError: 'Error subiendo archivo.',
    processingError: 'Error procesando su solicitud.',
    welcomeMessage: '¡Bienvenido! ¿Cómo puedo asistirlo con los servicios gubernamentales de Kenia hoy?',
    attachFile: 'Adjuntar Archivo',
    fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es {maxSize}.',
    saveChat: 'Guardar Chat',
    chatSaved: 'Chat Guardado',
    chatTitle: 'Título del Chat',
    chatTitlePlaceholder: 'Ingrese un título para este chat',
    selectFolder: 'Seleccionar Carpeta',
    newChat: 'Nuevo Chat',
    clearContext: 'Limpiar contexto e iniciar una nueva conversación',
    unsavedChanges: 'Tiene cambios no guardados. ¿Está seguro de que desea iniciar un nuevo chat?',
    whatCanIHelp: "¿Cómo puedo ayudarlo hoy?",
    justChat: "Solo Chatear",
    queryContext: "Contexto de Consulta",
    contextAdded: 'Contexto agregado a su consulta',
    contextRemoved: 'Contexto eliminado de su consulta',
    sessionUpdated: 'Sesión actualizada',
    newChatStarted: 'Iniciada una nueva conversación',
    loadError: 'No se pudo cargar el historial de chat',
    responsePrefix: "Recibí su mensaje",
    withContext: "con contexto",
    conversationLoaded: "¡Conversación cargada con éxito!",
    saveConfirmTitle: "Guardar Conversación Existente",
    saveConfirmMessage: "¿Guardar conversación existente?",
    loadConfirmTitle: "Cargar Conversación Existente",
    loadConfirmMessage: "Tiene cambios no guardados. ¿Desea descartarlos y cargar la conversación seleccionada, o guardar la conversación actual primero?",
    loadAndDiscard: "Cargar y Descartar",
    saveAndLoad: "Guardar y Cargar",
    saveAndStartNew: "Guardar e Iniciar Nuevo",
    discardAndStartNew: "Descartar e Iniciar Nuevo",
    newChatTitle: "Iniciar Nuevo Chat",
    exportChat: 'Exportar Chat',
    exportFilename: 'Nombre de Archivo',
    exportFilenamePlaceholder: 'Ingrese nombre de archivo',
    exportButton: 'Exportar',
    exportSuccess: 'Chat exportado con éxito',
    exportError: 'Falló la exportación del chat. Por favor, intente nuevamente.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Solicitar ID",
    payTaxes: "Pagar impuestos",
    startBusiness: "Iniciar negocio",
    findHealthcare: "Salud",
    educationServices: "Educación",
    transportLicenses: "Transporte",
    housingPrograms: "Vivienda",
    findJobs: "Empleos",
    justChat: "Solo Chatear",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "Me gustaría chatear sobre servicios gubernamentales",
    applyForIDUserPrompt: "Necesito información sobre cómo solicitar una tarjeta de ID nacional",
    payTaxesUserPrompt: "¿Cuál es el proceso para pagar mis impuestos en línea?",
    startBusinessUserPrompt: "Guíeme a través de los pasos para registrar un nuevo negocio",
    findHealthcareUserPrompt: "¿Dónde puedo encontrar información sobre servicios de salud pública?",
    educationServicesUserPrompt: "¿Qué servicios educativos están disponibles para mis hijos?",
    transportLicensesUserPrompt: "¿Cómo renuevo mi licencia de conducir?",
    housingProgramsUserPrompt: "Cuénteme sobre programas de vivienda asequible en Kenia",
    findJobsUserPrompt: "¿Qué oportunidades de empleo gubernamentales están disponibles actualmente?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Cancelar',
    create: 'Crear',
    save: 'Guardar',
    move: 'Mover',
    delete: 'Eliminar',
    // --- NEW KEYS ADDED ---
    ok: 'Aceptar',
    ingest: 'Ingerir',
    retract: 'Retractar',
    loading: 'Cargando...',
    refresh: 'Actualizar'
  },
  feedback: {
    title: 'Retroalimentación',
    button: 'Retroalimentación',
    positive: 'Retroalimentación positiva',
    negative: 'Retroalimentación negativa',
    promptText: '¿Fue útil esta respuesta?',
    placeholder: 'Comentarios adicionales...',
    submit: 'Enviar Retroalimentación',
    close: 'Cancelar',
    thankYouMessage: '¡Gracias por su retroalimentación!',
    submitting: 'Enviando...',
    error: 'Algo salió mal. Por favor, intente nuevamente.',
    success: '¡Gracias por su retroalimentación!',
  },
  responseRating: {
    title: 'Ayúdenos a Mejorar',
    note: 'Su retroalimentación se usará para ajustar mejor el chatbot y mejorar las respuestas con el tiempo.',
    chatbotResponse: 'Respuesta del Chatbot:',
    ratingLabels: {
      1: 'Inútil',
      2: 'Ligeramente Útil',
      3: 'Moderadamente Útil',
      4: 'Muy Útil',
      5: 'Cambia la Vida'
    },
    additionalComments: 'Comentarios adicionales...',
    submit: 'Enviar',
    cancel: 'Cancelar'
  },
  upload: {
    alt: 'Subir'
  },
  details: {
    loading: 'Cargando detalles del archivo...',
    title: 'Detalles del archivo',
    close: 'Cerrar',
    fileName: 'Nombre del archivo',
    author: 'Autor',
    labels: 'Etiquetas',
    selectAll: 'Seleccionar todo',
    loadingLabels: 'Cargando etiquetas...',
    status: 'Estado',
    fileId: 'ID del archivo',
    fileType: 'Tipo de archivo',
    viewFile: 'Ver archivo',
    visitLink: 'Visitar enlace externo',
    openFile: 'Abrir archivo en nueva pestaña',
    fileSize: 'Tamaño del archivo',
    uploadDate: 'Fecha de subida',
    hash: 'Hash SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Detalles",
      ingestionLog: "Registro de Ingestión"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Acciones de Detención:",
      killDocument: "Detener este Documento",
      killProcess: "Detener Proceso de Ingestión",
      timestamp: "Marca de Tiempo",
      level: "Nivel",
      stage: "Etapa",
      message: "Mensaje",
      loadingLogs: "Cargando registros...",
      noLogs: "No se encontraron registros."
    },
    buttons: {
      saveMetadata: 'Guardar metadatos',
      retract: 'Retractar',
      ingest: 'Ingerir'
    },
    notifications: {
      loadError: 'Error al cargar los detalles del archivo.',
      validationError: 'El nombre del archivo y el autor son obligatorios.',
      saveSuccess: 'Metadatos actualizados correctamente.',
      saveError: 'Error al guardar los metadatos.',
      tokenError: 'No se encontró el token de autenticación en los datos del usuario.',
      viewError: 'No se pudo cargar el archivo para su visualización.',
      ingestSuccess: 'El archivo se ha puesto en cola para su ingestión correctamente.',
      ingestError: 'Error al iniciar el proceso de ingestión.',
      retractSuccess: 'El archivo ha sido retractado correctamente.',
      retractError: 'Error al retractar el archivo.',
      deleteSuccess: 'Archivo eliminado correctamente.',
      deleteError: 'Error al eliminar el archivo.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Por favor, seleccione al menos una etiqueta antes de ingerir.",
      ingestSaving: "Guardando metadatos antes de la ingestión...",
      ingestSaveFailed: "Error al guardar metadatos. Ingestión cancelada.",
      logError: "Error al obtener los registros de ingestión.",
      killDocSent: "Se ha enviado la solicitud de detención para este documento.",
      killProcSent: "Se ha enviado la solicitud de detención para el proceso de ingestión."
    },
    confirm: {
      ingest: '¿Está seguro de que desea ingerir este archivo? Esto iniciará el proceso de tratamiento de datos.',
      retract: '¿Está seguro de que desea retractar este archivo?',
      delete: '¿Está seguro de que desea eliminar permanentemente este archivo? Esta acción no se puede deshacer.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Confirmar Ingestión",
      retractTitle: "Confirmar Retracción",
      deleteTitle: "Confirmar Eliminación",
      killDocTitle: "Detener Ingestión de Documento",
      killDoc: "¿Está seguro de que desea detener la tarea de ingestión para ESTE documento? El proceso intentará una anulación segura.",
      killProcTitle: "Detener TODO el Proceso de Ingestión",
      killProc: "ADVERTENCIA: Esto detendrá todo el servicio de ingestión de backend, afectando a TODOS los archivos que se están procesando actualmente. ¿Está absolutamente seguro?"
    }
  },
  uploadDialog: {
    title: 'Subir Archivos',
    dropzone: 'Arrastre y suelte archivos aquí, o haga clic para seleccionar',
    allowedTypesLabel: 'Tipos permitidos:',
    buttonUpload: 'Subir {count} Archivo(s)',
    remove: 'Eliminar',
    uploading: 'Subiendo...',
    notifications: {
      dropError: 'Solo se pueden soltar archivos. Por favor, verifique que está arrastrando un archivo válido desde su computadora.',
      typeNotAllowed: 'El tipo de archivo "{extension}" no está permitido.',
      shortcutUnsupported: 'Los archivos de acceso directo (.url) no son compatibles. Por favor, arrastre el archivo real.',
      duplicate: 'El archivo "{fileName}" ya ha sido agregado.',
      uploadSuccess: '{fileName} subido con éxito',
      uploadFailed: 'Falló la subida de {fileName}.'
    }
  }
}